import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TournamentPass } from '@fantaz/shared/data-access/models';
import { SkeletonModule } from '@fantaz/shared/ui/skeleton';
import { TournamentsUiPassCardComponent } from '@fantaz/tournaments/ui/pass-card';

@Component({
  selector: 'fz-pass-card-list',
  standalone: true,
  imports: [CommonModule, TournamentsUiPassCardComponent, SkeletonModule],
  templateUrl: './tournaments-ui-pass-card-list.component.html',
  styleUrls: ['./tournaments-ui-pass-card-list.component.scss'],
  animations: [
    trigger('slideInRight', [
      transition(':enter', [
        style({
          transform: 'translateX(24px)',
          opacity: 0.5,
        }),
        animate(
          '500ms ease-out',
          style({
            transform: 'translateX(0)',
            opacity: 1,
          }),
        ),
      ]),
      transition(':leave', [
        animate('500ms ease-out', style({ transform: 'translateX(10px)' })),
      ]),
    ]),
  ],
})
export class TournamentsUiPassCardListComponent {
  /**
   * Loaded state of the component, if false, the component will show a loading
   * placeholder
   */
  @Input()
  loaded?: boolean;

  /**
   * Error state of the component, if true, the component will show an error
   */
  @Input()
  error?: boolean;

  /**
   * Passes list to be displayed
   */
  @Input()
  passes?: TournamentPass[];

  /**
   * Tournament entry fee
   */
  @Input({ required: true })
  tournamentEntryFee: number;

  /**
   * Event emitted when a pass is pressed
   */
  @Output()
  passPressed: EventEmitter<TournamentPass> =
    new EventEmitter<TournamentPass>();

  /**
   * Event emitted when a pass is shared
   */
  @Output()
  sharePressed: EventEmitter<TournamentPass> =
    new EventEmitter<TournamentPass>();

  /**
   * Function to track the passes in the list by their uuid to avoid
   * re-rendering
   * @param index {number} - index of the pass in the list
   * @param pass {TournamentPass} - pass to be tracked
   * @returns {string} - pass uuid
   */
  trackByPassIdentifier(index: number, pass: TournamentPass): string {
    if (pass.fantazPassUuid) {
      return pass.fantazPassUuid;
    }
    return pass.uuid;
  }

  onSharePass(event: any) {
    console.log('onSharePass list', event);
    this.sharePressed.emit(event);
  }
}
